import React, { useContext } from "react";

import { Icon, IconButton } from "../components/ui";
import { UserContext } from "../contexts";
import { useChatSummary } from "./useMerchantChat";
import { useQuickChat } from "./quickChatStore";

/**
 * Topbar launcher for the quick-chat dock — deliberately next to the bell
 * rather than a fourth floating bubble bottom-right (the onboarding widget
 * and the beta reporter already live there).
 *
 * Shares the unread-summary query key with the sidebar badge, so one poll
 * feeds both and they can never disagree.
 */
const QuickChatButton = () => {
  const { user } = useContext(UserContext) ?? {};
  const { data } = useChatSummary(!!user);
  const { isOpen, toggle } = useQuickChat();
  const count = data?.unread_count ?? 0;

  if (!user) return null;

  return (
    <span className="ft-topbar__chat">
      <IconButton
        variant="ghost"
        size="md"
        label={count > 0 ? `Quick chat — ${count} unread` : "Quick chat with Retail Circle"}
        pressed={isOpen}
        onClick={() => toggle()}
      >
        <Icon name="MessageCircle" size="sm" />
      </IconButton>
      {count > 0 && (
        <span className="ft-topbar__chat-dot" aria-hidden="true">
          {count > 9 ? "9+" : count}
        </span>
      )}
    </span>
  );
};

export default QuickChatButton;
